module.exports = __webpack_public_path__ + "fonts/b351bd62abcd96e924d9f44a3da169a7.ttf";